module.exports = __webpack_public_path__ + "img/ba96f0420819fabe5923821832b9e44b.svg";